import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'

export default function FamilyWizardLayout({ children }: ChildrenProp) {
  return (
    <div className="flex-grow flex flex-col items-center justify-center">
      {children}
    </div>
  )
}

FamilyWizardLayout.Header = function ({
  children,
  className,
}: ChildrenProp & { className?: string }) {
  return (
    <div
      className={cn(
        `md:h-20 text-3xl text-center font-medium text-gray-900`,
        className
      )}
    >
      {children}
    </div>
  )
}

FamilyWizardLayout.Content = function ({
  children,
  className,
}: ChildrenProp & { className?: string }) {
  return (
    <div className={cn('flex-grow flex flex-col', className)}>{children}</div>
  )
}

FamilyWizardLayout.ActionBar = function ({
  children,
  className,
}: ChildrenProp & { className?: string }) {
  return (
    <div className={cn('flex w-full mt-10 mb-3', className)}>{children}</div>
  )
}
